


import React, { useEffect, useState } from "react";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
    BarChart,
    Bar,
} from "recharts";
import axios from "axios";

const Cateringanalysis = () => {
    const [vendorId, setVendorId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);

    const isMobile = window.innerWidth <= 768;
    const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#A28BFE"];

    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        if (storedVendorId) setVendorId(storedVendorId);
    }, []);

    useEffect(() => {
        if (!vendorId) return;

        const fetchData = async () => {
            try {
                const token = localStorage.getItem("authToken");
                if (!token) return;

                const res = await axios.get(
                    `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/orders/statistics/dashboard/${vendorId}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                setData(res.data);
                setLoading(false);
            } catch (err) {
                console.error("Error fetching report:", err);
                setLoading(false);
            }
        };

        fetchData();
    }, [vendorId]);

    if (loading) {
        return (
            <div
                style={{
                    height: "500px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "24px",
                    fontWeight: "bold",
                }}
            >
                Loading...
            </div>
        );
    }

    if (!data) {
        return <div>No Data Found</div>;
    }

    // ✅ Transform API response for charts
    const paymentData = data.paymentDistribution.map((p) => ({
        name: p.method,
        value: p.count,
        percent: parseFloat(p.percentage),
    }));

    const topItems = data.topSellingItems.map((item) => {
        const key = Object.keys(item)[0];
        return { name: key, orders: item[key] };
    });

    const monthlyData = [
        {
            month: "This Week",
            Orders: data.weeklyOrders,
            Revenue: data.weeklyRevenue,
        },
        {
            month: "Today",
            Orders: data.dailyOrders,
            Revenue: data.dailyRevenue,
        },
    ];

    return (
        <div
            className=""
            style={{
                overflowY: "auto",
                height: isMobile ? "700px" : "550px",
                marginTop: isMobile ? "250px" : "30px",
                scrollbarWidth: "none",
            }}
        >
            {/* Status Cards */}
            <div className="status-overview4">
                <div style={{ background: "gray", color: "#fff" }} className="status-card4">
                    <h3>Total Orders</h3>
                    <p>{data.totalOrders}</p>
                </div>
                <div style={{ background: "gray", color: "#fff" }} className="status-card4">
                    <h3>Total Revenue</h3>
                    <p>₹{data.totalRevenue}</p>
                </div>
                <div style={{ background: "gray", color: "#fff" }} className="status-card4">
                    <h3>Total Customers</h3>
                    <p>{data.totalCustomers}</p>
                </div>
                <div style={{ background: "gray", color: "#fff" }} className="status-card4">
                    <h3>Success Rate</h3>
                    <p>{data.successRate}</p>
                </div>
            </div>

            {/* Charts */}
            <div
                className="cardcolumn"
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    gap: "16px",
                    marginTop: "20px",
                }}
            >
                {/* Orders & Revenue */}
                <div style={{ padding: "16px", flex: "1 1 48%", minWidth: "300px" }}>
                    <h2
                        style={{
                            fontSize: "20px",
                            fontWeight: "bold",
                            color: "red",
                            marginBottom: "16px",
                        }}
                    >
                        Orders & Revenue
                    </h2>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={monthlyData}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="month" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="Orders" fill="#1f77b4" />
                            <Bar dataKey="Revenue" fill="#d62728" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>

                {/* Top Selling Items */}
                <div style={{ padding: "16px", flex: "1 1 48%", minWidth: "300px" }}>
                    <h2
                        style={{
                            fontSize: "20px",
                            fontWeight: "bold",
                            color: "red",
                            marginBottom: "16px",
                        }}
                    >
                        Top Selling Items
                    </h2>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={topItems}>
                            <CartesianGrid strokeDasharray="2 2" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="orders" fill="#1f77b4" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>

            {/* Payment Distribution */}
            <div style={{ padding: "16px", textAlign: "center" }}>
                <h2
                    style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "red",
                        marginBottom: "16px",
                    }}
                >
                    Payment Distribution
                </h2>
                <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                        <Pie
                            data={paymentData}
                            cx="50%"
                            cy="50%"
                            outerRadius={100}
                            dataKey="value"
                            label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
                        >
                            {paymentData.map((entry, index) => (
                                <Cell key={index} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip />
                        <Legend />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default Cateringanalysis;
